// The background job API returns the human-readable label
// ("Success"/"Failed"/"Error"), not the raw enum value.
export const TERMINAL_BACKGROUND_JOB_STATUSES = ["Success", "Failed", "Error"];

export const isBackgroundJobProcessing = (status: string) =>
  !TERMINAL_BACKGROUND_JOB_STATUSES.includes(status);

// Matches BACKGROUND_JOB_TYPES.OCR_RATED_AGE's display label
// (get_job_type_display), not the raw enum value.
export const OCR_RATED_AGE_JOB_TYPE = "OCR Rated Age";

// Shared by the modal and the page banner, so they stay in sync. Matches
// RatedAgeOCRWatcher's own interval, since the backend poller that
// actually finishes these jobs only runs every 3 minutes anyway.
export const RATED_AGE_JOB_POLL_INTERVAL_MS = 15000;
